import { render, staticRenderFns } from "./ReceptionsValuationSummary.vue?vue&type=template&id=3d4ed129&"
import script from "./ReceptionsValuationSummary.vue?vue&type=script&lang=js&"
export * from "./ReceptionsValuationSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports